export default __webpack_public_path__ + "assets/NavyFederal-795c329b5b417f4d76d805e56eb930cd.svg";